import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ routes }) => {
	const { pathname } = useLocation();

	useEffect(() => {
		// Check if the current pathname matches any route in the list
		const shouldScroll = routes.some((route) =>
			new RegExp(`^${route}`).test(pathname)
		);

		if (shouldScroll) {
			window.scrollTo(0, 0);
		}
	}, [pathname, routes]);

	return null;
};

export default ScrollToTop;
